module.exports = __webpack_public_path__ + "img/12-on.2eaa0e17.png";